'use client';
import AchievementItemV2 from '@/components/Achievements/AcievementsCardsV2/AchievementItemV2';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import { useRef, ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';

SwiperCore.use([Navigation, Autoplay]);

interface AchievementsListProps {
  achievementsList: Array<{
    titleIcon?: string | { url: string; alt: string };
    title: ReactNode | SerializedEditorState;
    subtitle?: ReactNode | SerializedEditorState;
    hover: ReactNode | SerializedEditorState;
    width?: number;
    height?: number;
  }>;
}

export default function AchievementsListV2({ achievementsList }: AchievementsListProps) {
  const swiperRef = useRef<any>(null);

  const handleMouseEnter = () => {
    swiperRef.current.autoplay.stop();
  };

  const handleMouseLeave = () => {
    swiperRef.current.autoplay.start();
  };
  return (
    <div data-meta="AchievementsListV2" className="overflow-hidden relative mt-12">
      <Swiper
        onSwiper={swiper => {
          swiperRef.current = swiper;
        }}
        modules={[Autoplay, Navigation]}
        spaceBetween={30}
        slidesPerView={4}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 4,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          960: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1600: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          1920: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        }}
        centeredSlides={true}
        loop={true}
        speed={2500}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {achievementsList.map((item, index) => (
          <SwiperSlide key={index} className="!flex !justify-center">
            <AchievementItemV2 achievementItem={item} swiperRef={swiperRef} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
